/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { AuthenticationService } from '../_services/authentication/authentication.service';
import { NavController } from '@ionic/angular';
import { LoggingService } from '../_services/logging/logic/logging.service';

/**
 * A guard that ensures the user is authenticated before giving access to a specific path
 *
 * See [[CanActivate]] for more details
 */
@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private navController: NavController,
    private logger: LoggingService
  ) {}

  canActivate(): boolean {
    if (this.authenticationService.isAuthenticated()) {
      return true;
    } else {
      this.logger.log(
        this.constructor.name,
        '- User not authenticated - redirect to login'
      );
      this.navController.navigateRoot('/login');
      return false;
    }
  }
}
